











































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import OrgErrorMessage from '@/components/OrgErrorMessage.vue';
import i18n from '@/i18n/index';

export enum MessageType {
  None,
  FaceNotFound,
  DifferentDirection,
  Timeout,
  InvalidScreenOrientation,
  Unknown
}

interface MessageHtmls {
  FaceNotFound: string;
  DifferentDirection: string;
  Timeout: string;
  InvalidScreenOrientation: string;
  Unknown: string;
}

interface CautionMessage {
  Title: string;
  Description: string;
}

@Component({
  components: { OrgErrorMessage }
})
export default class FaceDirectionModal extends Vue {
  @Prop({ type: Boolean, required: true })
  active!: boolean;

  private isActive: boolean = this.active;

  @Prop({ type: Number, default: MessageType.None })
  messageType: MessageType = MessageType.None;

  @Prop({ type: Boolean, default: false })
  isManyRetry: boolean = false;

  @Prop({ type: String, default: '' })
  installationOperatorName!: string;

  @Prop({ type: Boolean, default: false })
  isInvalidOrientation!: boolean;

  @Emit('update:active')
  private activeUpdated(value: boolean) {}

  @Emit()
  private retry() {}

  @Emit()
  private help() {}

  @Watch('active')
  private onActiveChanged(newValue: boolean) {
    this.isActive = this.active;
  }

  get messageHtml(): string {
    switch (this.messageType) {
      case MessageType.FaceNotFound:
        return i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.FaceNotFound');

      case MessageType.DifferentDirection:
        return i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.DifferentDirection');

      case MessageType.Timeout:
        return i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.Timeout');

      case MessageType.InvalidScreenOrientation:
        return i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.InvalidScreenOrientation');

      case MessageType.None:
        return '';

      case MessageType.Unknown:
      default:
        return i18n.tc('componentsfacetrackerFaceDirectionModal.MessageHtmls.Unknown');
    }
  }

  get cautionMessageHtml(): CautionMessage[] {
    switch (this.messageType) {
      case MessageType.FaceNotFound:
        return [
          {
            Title: i18n.tc('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.FaceNotFound[0].Title'),
            Description: i18n.tc(
              'componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.FaceNotFound[0].Description'
            )
          },
          {
            Title: i18n.tc('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.FaceNotFound[1].Title'),
            Description: i18n.tc(
              'componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.FaceNotFound[1].Description'
            )
          }
        ];

      case MessageType.DifferentDirection:
        return [
          {
            Title: i18n.tc('componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.DifferentDirection[0].Title'),
            Description: i18n.tc(
              'componentsfacetrackerFaceDirectionModal.CautionMessageHtmls.DifferentDirection[0].Description'
            )
          }
        ];

      case MessageType.Timeout:
        return [];

      case MessageType.None:
        return [];

      case MessageType.Unknown:
      default:
        return [];
    }
  }

  get isCautionMessageVisible(): boolean {
    return this.cautionMessageHtml.length !== 0;
  }

  mounted() {
    this.isActive = this.active;
  }
}
